import cn from 'clsx';
import React from 'react';
import { DH } from '../../utils/DataHook';
import s from './style.scss';

export const GeneralError = ({ generalErrorMessage }) => {
  const errorIcon = require('../../assets/img/error-icon-modal.svg?url');

  return (
    <div data-hook={DH.GeneralError} role="alert" className={cn(s.generalError, s.modal)}>
      <div className={s.generalErrorContent}>
        <img className={s.circleIcon} src={errorIcon} alt="" />
        <span className={s.generalErrorText} title={generalErrorMessage}>
          {generalErrorMessage}
        </span>
      </div>
    </div>
  );
};
